var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{staticClass:"errorPage is-404"},[_c('b-icon',{attrs:{"icon":"poo"}}),_c('h1',[_vm._v("You got 404'd")]),_c('p',[_vm._v("The page you're looking for does not exist. Sorry :'(")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }